import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { LoadAllEvent, UpdateEvent } from '../../../actions/Activites/Evenement';
import ModalAddEvent from '../../../modal/admin/actvites/ModalAddEvent';
import { baseUrl } from '../../../nametitle/dataUrl';
import LoaderBootStrap from '../dasboard/LoaderBootStrap';

const ListEventAdmin = () => {
  const navigate = useNavigate("");
  const [idEvent, setidEvent] = useState("");
  const [title, settitle] = useState("");
  const [date, setdate] = useState("");
  const [description, setdescription] = useState("");
  const [coverPicture, setcoverPicture] = useState("");
  const [visible, setvisible] = useState();

  // *************************************************** Photo
  const [Loading, setLoading] = useState();
  


  const [search, setsearch] = useState("");
  const [EventList, setEventList] = useState([]);
  const [SearchEventList, setSearchEventList] = useState([]);
  useEffect(() => {
    LoadAllEvent(setEventList);
    LoadAllEvent(setSearchEventList);
  }, []);


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader(); fileReader.readAsDataURL(file); fileReader.onload = () => { resolve(fileReader.result); };
      fileReader.onerror = (error) => { reject(error); };
    });
  };

  // Video 
  function uploadSingleImage(base64) {
    setLoading(true);
    axios.post(`${baseUrl.baseUrl}/uploadImage`, { image: base64 })
      .then((res) => { setcoverPicture(res.data); alert("image uploaded Succesfully"); })
      .then(() => setLoading(false))
      .catch(console.log);
  }
  const HandleFileInputChange = async (event) => {
    const files = event.target.files;
    console.log(files.length);
    if (files.length === 1) {
      const base64 = await convertBase64(files[0]);
      uploadSingleImage(base64); return;
    }
    const base64s = [];
    for (var i = 0; i < files.length; i++) { var base = await convertBase64(files[i]); base64s.push(base); }
  };

  return (
    <div>
      <div className="w-full container-fluid py-5">

        <div className="w-full flex space-x-3 justify-between mb-5">
          <div className="input-group">
            <input type="text" className="form-control p-1" placeholder="rechercher evenement ..." />
            <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
          </div>
          {/* Ajouter button */}
          <button className="btn btn-primary px-4" data-bs-toggle="modal" data-bs-target="#addModal" >Ajouter</button>
        </div>
        {/* Modal Add Event */}
        <ModalAddEvent />

        <div className="w-full ">
          <div className="w-full blog-item mb-5">
            {
              EventList && EventList.length > 0 ?
                (
                  EventList.map((item) => {
                    return (
                      <div className="w-full my-2 visible relative w-full row g-0 bg-light overflow-hidden">
                        <div className="col-12 col-sm-5 h-50">
                          <img className="img-fluid h-[300px] w-[300px]" src={item.coverPicture} style={{ objectFit: "cover" }} />
                        </div>
                        <div className="col-12 col-sm-7 h-100 d-flex flex-column justify-content-center">
                          <div className="p-4">
                            <div className="d-flex mb-3">
                              <small className="me-3"><i className="bi bi-bookmarks me-2"></i><span className="translatable">type evement</span></small>
                              <small><i className="bi bi-calendar-date me-2 translatable"></i>01 Jan, 2045 {item.date}</small>
                            </div>
                            <h5 className="text-uppercase mb-3 translatable"> evenement 1 {item.title}</h5>
                            <p className="line-clamp-2 translatable">{item.description}Ipsum sed lorem amet dolor amet duo ipsum amet et dolore est stet tempor eos dolor</p>
                            <a className="text-primary text-uppercase" href="#voire-evenement"><span className="translatable">voire</span><i className="bi bi-chevron-right"></i></a>
                          </div>
                        </div>
                        <div className="absolute top-1 right-3">
                          {/* Modifier */}
                          <button type="button"
                            onClick={() => { 
                              setidEvent(item._id);
                              settitle(item.title);
                              setdescription(item.description);
                              setcoverPicture(item.coverPicture);
                              setdate(item.date);
                              setvisible(item.visible);
                            }}
                            className="btn btn-outline-primary py-1 px-2 translatable" data-bs-toggle="modal" data-bs-target="#updateModal">modifier</button>
                        </div>
                        {/* Modal Event */}
                        <div className=" modal fade " id="updateModal" tabIndex="-2" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div className="modal-dialog">
                            <div className="modal-content rounded-0">
                              <div className="modal-header relative">
                                <h6 className=" modal-title  text-primary text-uppercase display-7 text-uppercase mb-0 translatable" id="exampleModalLabel" style={{ maxWidth: "600px" }}>
                                  Modifier evenement
                                </h6>
                                <button type="button" className="absolute top-3 right-4 btn btn-close text-2xl " data-bs-dismiss="modal" aria-label="Close">X</button>
                              </div>
                              <div className="modal-body h-[500px] container flex justify-center">
                                <div className="flex justify-center row g-8">
                                  <div className="col-lg-9">
                                    <form onSubmit={(e) => {
                                      e.preventDefault();
                                      UpdateEvent(idEvent, title, coverPicture, description, date,visible, navigate);
                                    }}>
                                      <div className="row g-3">
                                        <div className="col-12">
                                          <input type="text" value={title} onChange={(e) => { settitle(e.target.value) }} className="form-control bg-light border-0 px-4 py-1 translatable" placeholder="titre" style={{ height: "40px" }} />
                                        </div>
                                        <div className="col-12 flex">
                                          <input type="file" onChange={HandleFileInputChange} accept=".JPNG,.JPEG,.PNG" className="form-control bg-light border-0 px-4 translatable" placeholder="image" style={{ height: "40px" }} />
                                          <img src={`${coverPicture}`} className="h-[50px] h-[50px]" />
                                        </div>
                                        <div className="col-12 flex">
                                          <label className="form-control border-0 px-4" style={{ height: "40px" }}>date</label>
                                          <input type="date" value={date} onChange={(e) => { setdate(e.target.value) }} className="form-control bg-light border-0 px-4 translatable" placeholder="date" style={{ height: "40px" }} />
                                        </div>
                                        <div className="col-12">
                                          <textarea value={description} onChange={(e) => { setdescription(e.target.value) }} className="form-control bg-light border-0 px-4 translatable" placeholder="description de l'evement ..../donne par ../but../" style={{ height: "155px" }} />
                                        </div>
                                        <div className="col-12 flex items-center">
                                          <label className="form-control border-0 px-2 translatable" style={{ height: "40px" }}>visibilité</label>
                                          <input type="checkbox" className="form-check-input form-control border-0 px-4 translatable" checked={visible}  onChange={(e) => { setvisible(e.currentTarget.checked) ;  console.log(visible)}}  placeholder="date" style={{ height: "40px" }} />
                                        </div>
                                        <div className="col-12">
                                          <button className="btn btn-outline-primary w-100 py-3 translatable" type="submit">Modifier cet evenement</button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    )
                  })
                ) :
                <LoaderBootStrap/>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
export default ListEventAdmin;